import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// Material Modules
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

// Modules
import { ElementsModule } from '@modules/elements/elements.module';

// Components
import { UsersManagementComponent } from './components/users-management/users-management.component';
import { UserSettingsComponent } from './components/user-settings/user-settings.component';
import { AddUserComponent } from './components/add-user/add-user.component';
import { AddTeamComponent } from './components/add-team/add-team.component';



@NgModule({
  imports: [
    CommonModule,
    FormsModule,

    // Materials
    MatDialogModule,
    MatIconModule,
    MatMenuModule,

    ElementsModule,
  ],
  declarations: [
    UsersManagementComponent,
    UserSettingsComponent,
    AddUserComponent,
    AddTeamComponent,
  ],
  exports: [
    UsersManagementComponent,
    UserSettingsComponent,
  ],
})
export class UsersModule { }
